import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function RequestAConsultation() {
  return <section data-section-id="245716" id="request-a-consultation" className="bg-[#070D1A] py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4">
        <div className="rounded-lg p-0 text-center relative overflow-hidden animate-in fade-in duration-1000">
          <div className="relative z-10 flex flex-col items-center">
            <div className="mb-8">
              <span className="text-[#D6DCE8] text-sm font-medium font-mono uppercase tracking-widest">
                LET’S DISCUSS YOUR REQUIREMENTS
              </span>
            </div>

            <h2 className="text-4xl mb-6 tracking-tight max-w-3xl !font-sans !font-semibold text-white md:text-5xl lg:text-6xl">
              Strengthen Your Security and Technology Capabilities
            </h2>

            <p className="text-[#D6DCE8] text-lg md:text-xl max-w-2xl mx-auto mb-10 font-default">
              Engage with FETC to explore practical cybersecurity, governance, technology modernization and digital transformation solutions tailored to your organization.
            </p>

            <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-4 transition-all duration-400 rounded-md px-10 h-14 text-lg font-semibold !bg-[#0F62FE] !text-white disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:!bg-[#0043CE] hover:shadow-lg hover:-translate-y-0.5">
              <Link to="/ContactUsPage">
                Request a Consultation
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}